var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTvHoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#A1887F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 8.50065C5.52148 10.0315 4.83398 11.9382 4.83398 14.0007C4.83398 19.0607 8.94065 23.1673 14.0007 23.1673C19.0607 23.1673 23.1673 19.0607 23.1673 14.0007C23.1673 8.94065 19.0607 4.83398 14.0007 4.83398C12.6898 4.83398 11.434 5.10898 10.3065 5.61315",
    stroke: "#A1887F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.325 17.555V10.445C13.325 9.77 13.04 9.5 12.32 9.5H10.505C9.785 9.5 9.5 9.77 9.5 10.445V17.555C9.5 18.23 9.785 18.5 10.505 18.5H12.32C13.04 18.5 13.325 18.23 13.325 17.555Z",
    fill: "#A1887F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5008 17.555V10.445C18.5008 9.77 18.2158 9.5 17.4958 9.5H15.6808C14.9658 9.5 14.6758 9.77 14.6758 10.445V17.555C14.6758 18.23 14.9608 18.5 15.6808 18.5H17.4958C18.2158 18.5 18.5008 18.23 18.5008 17.555Z",
    fill: "#A1887F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvHoldIcon);
export default __webpack_public_path__ + "static/media/tvHoldIcon.2dc3d24bc09c837ac0043980f63c6cfb.svg";
export { ForwardRef as ReactComponent };